module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Add User")]), _vm._v(" "), _c('section', {
    staticClass: "User"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    staticClass: "ui form addUserForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.$_admin_user_add_checkAddUser($event)
      }
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6",
    class: {
      'form-group has-error': _vm.$v.email.$invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].email) + ":")]), _vm._v(" "), (!_vm.$v.email.required) ? _c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].required))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    ref: "addUserEmail",
    staticClass: "form-control",
    attrs: {
      "placeholder": "email",
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    class: {
      'form-group has-error': _vm.$v.phone.$invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].phone) + ":")]), _vm._v(" "), (!_vm.$v.phone.required) ? _c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].required))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "phone",
      "type": "text"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6",
    class: {
      'form-group has-error': _vm.$v.password.$invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].password) + ":")]), _vm._v(" "), (!_vm.$v.password.required) ? _c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].required))]) : _vm._e(), _vm._v(" "), (!_vm.$v.password.minLength) ? _c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].minLength))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "password",
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    class: {
      'form-group has-error': _vm.$v.confirmPassword.$invalid
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].confirmPassword) + ":")]), _vm._v(" "), (!_vm.$v.confirmPassword.sameAsPassword) ? _c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].sameAsPassword))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "confirmPassword",
      "type": "password"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].type) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(5), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "private"
    }
  }, [_vm._v("private")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "company"
    }
  }, [_vm._v("company")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].companyName) + ":")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.companyName),
      expression: "companyName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "companyName",
      "type": "text"
    },
    domProps: {
      "value": (_vm.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.companyName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].status) + ":")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "unconfirmed"
    }
  }, [_vm._v("unconfirmed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "confirmed"
    }
  }, [_vm._v("confirmed")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "archived"
    }
  }, [_vm._v("archived")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].wantMessage) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.wantMessage),
      expression: "wantMessage"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.wantMessage) ? _vm._i(_vm.wantMessage, null) > -1 : (_vm.wantMessage)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.wantMessage,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.wantMessage = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.wantMessage = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.wantMessage = $$c
        }
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    class: {
      overlay: true, hidden: !_vm.loading
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    class: 'btn btn-warning btn-lg ' + _vm.loading,
    attrs: {
      "type": "button",
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": _vm.$t('clear')
    },
    on: {
      "click": function($event) {
        _vm.$_admin_user_add_clearInput()
      }
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$i18n.messages[_vm.$i18n.locale].clear) + "\n                                ")]), _vm._v(" "), _c('button', {
    class: 'btn btn-primary btn-lg ' + _vm.loading,
    attrs: {
      "type": "submit",
      "disabled": _vm.$v.$invalid,
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": _vm.$t('submit')
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$i18n.messages[_vm.$i18n.locale].submit) + "\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    class: {
      overlay: true, hidden: !_vm.loading
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-success alert-dismissible",
    class: {
      hidden: !_vm.insertSuccess
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.$_admin_user_add_closeAndRedirect()
      }
    }
  }, [_vm._v("\n                            ×\n                        ")]), _vm._v(" "), _c('h4', [_c('i', {
    staticClass: "icon fa fa-check"
  }), _vm._v(" " + _vm._s(_vm.$i18n.messages[_vm.$i18n.locale].success) + "!")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Inputs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-balance-scale",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-balance-scale",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-balance-scale",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-balance-scale",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-edit",
    attrs: {
      "aria-hidden": "true"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-fw fa-balance-scale",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b6c593d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/AddUser.vue
// module id = 1478
// module chunks = 1